module.exports = __webpack_public_path__ + "media/newstyle/images/icon-money-orange-4c1ddeb9c6c15f7a64da7039d48694cc.svg";